<template>
  <div ref="chartContainer" style="width: 600px; height: 400px;"></div>
</template>

<script>
export default {
  name: 'MosquitoChart',
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const chart = echarts.init(this.$refs.chartContainer);
      const data = [
       [10, 20, 30, 40, 50],
       [20, 30, 40, 50, 60],
       [30, 40, 50, 60, 70],
     ];
    var option = {
  title: [
    {
      text: ' '
    }
  ],
  polar: {
    radius: [30, '80%']
  },
  angleAxis: {
    max: 15,
    startAngle: 75
  },
  radiusAxis: {
    type: 'category',
    // data: ['a','borderColor']
    name: '',
    axisLabel: {
      show: false
    }
  },

  tooltip: {
    show: true,
    formatter: function (params) {
      return 'dfkdfhk ';
    }
  },
  legend: {
    show: true
  },
  series: [
    {
      type: 'bar',
      data: [2],
      name: 'd1',
      coordinateSystem: 'polar',
      roundCap: true,
      label: {
        show: true,
        position: 'start',
        formatter: function (params) {
          // console.log(params);
          return '货车';
        }
        // offset:[30,30]
      }
    },
    {
      type: 'bar',
      data: [3],
      name: 'd2',
      coordinateSystem: 'polar',
      label: {
        show: true,
        position: 'start',
        formatter: '{b}: {c}'
      }
    },
    {
      type: 'bar',
      data: [4],
      name: 'd3',
      coordinateSystem: 'polar',
      label: {
        show: true,
        position: 'start',
        formatter: '{c}'
      }
    },
    {
      type: 'bar',
      data: [7],
      name: 'd4',
      coordinateSystem: 'polar',
      label: {
        show: true,
        position: 'start',
        formatter: '{b}: {c}'
      }
    }
  ]
};
      chart.setOption(option);
    }
  }
};
</script>